import React, { useState } from "react"
import Popup from "reactjs-popup"
import ReactMarkdown from "react-markdown"

const TransitionAccept = ({
	title,
	message,
	isOpen,
	onAccept,
	onDecline,
	verbose,
	setVerbose,
	remove = false
}) => {
	const [acceptClicked, setAcceptClicked] = useState(false)

	// Handle accept click
	const handleAccept = () => {
		setAcceptClicked(true)
		onAccept()
	}

	// Handle popup close
	const handleClose = () => {
		if (!acceptClicked) {
			onDecline()
		}
		setAcceptClicked(false)
	}

	return (
		<Popup
			open={isOpen}
			modal
			nested
			closeOnDocumentClick
			closeOnEscape
			onClose={handleClose}
			contentStyle={{
				width: "auto",
				border: "none",
				borderRadius: "10px",
				padding: "0"
			}}
			overlayStyle={{ background: "rgba(0, 0, 0, 0.5)" }}
		>
			<div className="bg-white p-6 rounded-xl shadow-md mx-auto max-h-[85vh] flex flex-col">
				<div className="flex justify-between items-center mb-4 flex-shrink-0">
					<div className="text-xl font-semibold text-custom-blue">{title}</div>
					{verbose !== undefined && (
						<label className="inline-flex items-center cursor-pointer">
							<span className="mr-2 text-gray-700">
								{verbose ? "Show Less" : "Show More"}
							</span>
							<div className="relative">
								<input
									type="checkbox"
									className="hidden"
									checked={verbose}
									onChange={() => setVerbose(!verbose)}
								/>
								<div className="block bg-gray-200 w-14 h-8 rounded-full"></div>
								<div
									className={`absolute left-1 top-1 w-6 h-6 rounded-full transition-transform ${verbose ? "bg-custom-blue" : "bg-white"} ${verbose ? "transform translate-x-full" : ""}`}
								></div>
							</div>
						</label>
					)}
				</div>
				<div className="sensitive ph-no-capture prose prose-slate prose-lg text-black prose-li:text-black flex-1 min-h-0 overflow-y-auto mb-4 leading-relaxed text-left">
					<ReactMarkdown>{message}</ReactMarkdown>
				</div>
				<div className="flex justify-end flex-shrink-0 pt-2 border-t border-gray-100">
					<button
						onClick={onDecline}
						className="mr-2 bg-gray-200 text-gray-800 px-4 py-2 rounded"
					>
						Decline
					</button>
					<button
						onClick={handleAccept}
						className="bg-custom-blue text-white px-4 py-2 rounded"
					>
						{remove ? "Accept and Delete" : "Accept"}
					</button>
				</div>
			</div>
		</Popup>
	)
}

export default TransitionAccept
